import React, { useState } from 'react';
import { useMutation } from '@common/hooks';
import { createMessage } from 'works/legacy/lib/message-helper';
import { Button } from 'antd';
import { SizeType } from 'antd/lib/config-provider/SizeContext';
import { PERFORM_EXTENSION_OFFER_ACTION_MUTATION } from '@working-experience/graphql';

export function ExtensionOfferActionRetract({
  extensionOfferId,
  buttonText = 'Retract Extension Offer',
  disabled = false,
  size,
}: {
  extensionOfferId: string;
  buttonText: string;
  disabled?: boolean;
  size?: SizeType;
}) {
  const [loading, setLoading] = useState(false);

  const [performRetractExtensionOfferAction] = useMutation(
    PERFORM_EXTENSION_OFFER_ACTION_MUTATION,
    {
      onCompleted() {
        createMessage('success', 'Extension Offer successfully retracted!');
      },
      onError: () => {
        setLoading(false);
        createMessage(
          'error',
          'Extension Offer could not be retracted. Please try again or contact your hiring partner.'
        );
      },
      refetchQueries: ['CandidateAssignmentQuery'],
    }
  );

  const onClick = () => {
    setLoading(true);
    performRetractExtensionOfferAction({
      variables: {
        extensionOfferId: extensionOfferId,
        input: {
          action: 'retract',
        },
      },
    });
  };

  return (
    <Button
      danger
      loading={loading}
      onClick={onClick}
      disabled={disabled}
      size={size}
    >
      {buttonText}
    </Button>
  );
}
